import React from 'react'
import { RotatingLines } from 'react-loader-spinner'


const Buffering = () => {
    return (
        <div className='d-flex w-100 justify-content-center align-items-center'>
            <RotatingLines
                strokeColor="grey"
                strokeWidth="3"
                animationDuration="0.75"
                width="40"
                visible={true}
            />
        </div>
    )
}

export default Buffering